import React from 'react';

/* The Iron Triangle isotype — three squares, apex up. Inherits currentColor. */
export function Isotype({ size = 24, style, ...rest }) {
  return (
    <svg width={size} height={size * 0.92} viewBox="0 0 100 92" fill="currentColor"
      role="img" aria-label="Coachability mark" style={style} {...rest}>
      <rect x="37" y="0" width="26" height="26" />
      <rect x="0" y="66" width="26" height="26" />
      <rect x="74" y="66" width="26" height="26" />
    </svg>
  );
}

/**
 * Coachability logo. variant: "wordmark" | "lockup" | "full" | "isotype"
 */
export default function Logo({ variant = 'wordmark', size = 28, color = 'var(--ink)', markColor, style, ...rest }) {
  const wrap = {
    display: 'inline-flex', alignItems: 'center', gap: `${size * 0.42}px`, color,
    fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)', lineHeight: 1, ...style,
  };
  const word = {
    fontSize: `${size}px`, letterSpacing: 'var(--track-wide)',
    textTransform: 'uppercase', whiteSpace: 'nowrap',
  };
  if (variant === 'isotype') {
    return <Isotype size={size} style={{ color: markColor || color, ...style }} {...rest} />;
  }
  if (variant === 'lockup') {
    // COACH + mark — the compact app/signage form
    return (
      <span style={wrap} {...rest}>
        <span style={word}>Coach</span>
        <Isotype size={size * 0.62} style={{ color: markColor || 'var(--science-400)' }} />
      </span>
    );
  }
  if (variant === 'full') {
    return (
      <span style={{
        display: 'inline-flex', flexDirection: 'column', color,
        fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)',
        lineHeight: 0.96, letterSpacing: 'var(--track-tight)', textTransform: 'uppercase', ...style,
      }} {...rest}>
        <span style={{ fontSize: `${size}px` }}>Coachability</span>
        <span style={{ fontSize: `${size}px`, display: 'inline-flex', alignItems: 'flex-start', gap: '0.18em' }}>
          Consultants
          <sup style={{ fontSize: '0.42em', fontWeight: 'var(--w-medium)', letterSpacing: '0.05em', marginTop: '0.15em' }}>INC.</sup>
        </span>
      </span>
    );
  }
  // wordmark (default)
  return (
    <span style={{ ...wrap, gap: 0 }} {...rest}>
      <span style={word}>Coachability</span>
    </span>
  );
}
